import styled, { css } from 'styled-components';

// The checkmark keeps its slot when unchecked so the labels of checked and
// unchecked rows stay on the same line-up as the menu's other items.
export const CheckSlot = styled.span<{ $checked: boolean }>`
  display: inline-flex;

  ${({ $checked }) =>
    !$checked &&
    css`
      opacity: 0;
    `};
`;
